import axios from 'axios'
import CryptoJS from 'crypto-js'
import Qs from 'qs'

// create an axios instance
import {
  Decrypt,
  Encrypt
} from "./crypt";
const service = axios.create({
	baseURL: 'https://api.uatas.id/',
	headers: {
		// 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
	},
	method: 'POST',
	responseType: 'json',
})

// request interceptor
service.interceptors.request.use(
	(config) => {
    config.data = {
      data: Encrypt(JSON.stringify(config.data)),
      encrypt: 2
    }
    // console.log(Decrypt(config.data.data))
		return config
	},
	(error) => {
	
		console.log(error) // for debug
		return Promise.reject(error)
	}
)

service.interceptors.response.use(
	(response) => {
		// console.log(response)
		if (response.status !== 0&&response.status !==200) {
			return Promise.reject(response.data)
		} else {
			return response.data
		}
	},
	(error) => {
		return Promise.reject(error)
	}
)

export default service



// WEBPACK FOOTER //
// ./src/request/axios.js